(function() {
  const isProductPage = window.location.pathname.indexOf('/products/') !== -1;
  
  if (!isProductPage) return;

  const overrideYmalSkeleton = () => {
    const style = document.createElement('style');
    style.id = 'salepify-ymal-hide-skeleton-css';
    style.innerHTML = `
      .salepify-ymal-text-skeletion,
      .salepify-ymal-thumbnail-skeletion,
      .skeleton-lazy-load {
        display: none !important;
      }
    `;
    document.head.appendChild(style);

    customElements.whenDefined('salepify-ymal').then(() => {
      const YmalWidget = customElements.get('salepify-ymal');
      
      if (YmalWidget && YmalWidget.prototype) {
        YmalWidget.prototype.setLoading = function() {
          this.innerHTML = "";
          this.style.setProperty("display", "none", "important");
          if (typeof this.setWidthToWidget === 'function') {
            this.setWidthToWidget();
          }
        };

        YmalWidget.prototype.renderLazyLoadSkeleton = function() {
          return "";
        };
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', overrideYmalSkeleton);
  } else {
    overrideYmalSkeleton();
  }
})();
